export const id = {
  id: {
    translation: {
      confirm_app_exit: 'Apakah Anda yakin ingin meninggalkan Baby Shark World for Kids?',
      button_exit: 'Tutup',
      button_cancel: 'Batal',
      os_update: 'Silakan gunakan setelah memperbarui ke versi TV OS terbaru.',
      button_ok: 'OK',
      t_complete_app_update: 'Dunia Baby Shark untuk Anak telah diperbarui.',
      error_title: 'Terjadi kesalahan',
      error_unknown: 'Silakan coba lagi.',
      error_network_title: 'Koneksi internet tidak stabil.',
      error_network: 'Periksa koneksi jaringan Anda dan coba lagi.',
      button_retry: 'Ulangi',
      confirm_continue_watching: 'Apakah Anda ingin terus menonton?',
      button_continue_watching: 'Tonton Dari Awal',
      button_from_beginning: 'Dari awal.',
      t_event_coming_soon: 'Saat ini sedang dalam persiapan untuk acara.',
      data_fail: 'Terjadi kesalahan.\nSilakan coba lagi.',
      page_sign_in_header: 'Pindai kode QR',
      page_sign_in: 'Untuk menggunakan layanan ini, Anda perlu masuk.\nSilakan pindai kode QR untuk login.',
      page_sign_in_code: 'Kode Verifikasi',
      page_sign_in_time: 'Waktu Tersisa',
      oauth_confirm_code: 'Silakan cek\napakah sesuai dengan kode verifikasi TV',
      oauth_web_info: 'Penjelajah web',
      oauth_device_info: 'Informasi akses perangkat.',
      oauth_accept_sign_in: 'Terima masuk',
      oauth_sign_in_success: 'Pendaftaran perangkat berhasil.',
      oauth_sign_in_cancel: 'Pendaftaran perangkat dibatalkan.',
      oauth_sign_in_fail: 'Error.\nCoba masuk kembali dengan kode QR.',
      oauth_sign_in_expired: 'Sesi login kadaluarsa.\nPindai ulang kode QR TV untuk masuk.',
      menu_my: 'MY',
      menu_home: 'Home',
      menu_story: 'Cerita',
      menu_song: 'Lagu',
      menu_cinema: 'Film',
      menu_cinema_and_tv: 'Film & Seri TV',
      menu_ip: 'IP',
      menu_topics: 'Topik',
      menu_home_history: 'Baru Saja Ditonton',
      title_ai_videos: 'Video yang Disusun oleh AI',
      menu_home_new_content: 'Apa Yang Baru',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: 'Tidak ada langganan aktif',
      mypage_menu_status_susbcribed: 'Berlangganan Pinkfong Plus',
      mypage_menu_benefits_unsusbcribed: 'Manfaat langganan',
      mypage_menu_benefits_susbcribed: 'Manfaat Saat Ini',
      mypage_menu_benefits_01: 'Lebih dari 20.000 seri asli tersedia',
      mypage_menu_benefits_02: 'Secara berkala diperbarui,\nmenyediakan konten',
      mypage_menu_benefits_03: 'Sekali mendaftar,\ndapat digunakan secara bersamaan di TV dan ponsel',
      mypage_menu_benefits_04: 'Lebih dari 30 aplikasi pembelajaran menarik\ndengan akses tanpa batas',
      mypage_scan_to_subscribe: 'Pindai kode QR untuk berlangganan',
      mypage_video_title: 'Apa itu Pinkfong Plus?',
      mypage_menu_terms: 'Syarat Penggunaan',
      mypage_menu_event: 'Promosi',
      mypage_menu_support: 'Dukungan',
      button_sign_out: 'Keluar',
      mypage_menu_event_coming_soon: 'Segera Hadir',
      mypage_menu_even_open: 'Buka',
      terms_required_privacy: 'Kebijakan Privasi',
      terms_required_pinkfong: 'Syarat Layanan',
      terms_required_interactive: 'Pinkfong Interaktif Aplikasi Ketentuan Layanan',
      mypage_menu_device_info: 'Informasi Perangkat',
      page_device_info: 'Berikan informasi berikut untuk mendukung pemecahan masalah lebih cepat.',
      page_device_info_model: 'Model Perangkat',
      page_device_info_os: 'Sistem Operasi Platform',
      page_device_info_version: 'Versi Aplikasi',
      page_support:
        'Jika Anda memiliki pertanyaan mengenai penggunaan layanan,\nsilakan hubungi kami di alamat email berikut.\ncs@pinkfong.com',
      caution_sign_out: 'Logout akan membatasi akses ke layanan.',
      topic_category_all: 'All',
      player_language_button: 'Bahasa',
    },
  },
};
